import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { createSelector } from 'reselect';
import { getDataWeatherData } from '../../../../../slices/dataWeather/thunk';
import OPlaceholder from '../../../../../Components/OElements/OPlaceholder';

const WeatherForecast = ({ code_siep, lat, lon }) => {
    const dispatch = useDispatch();
    const hasFetchedData = useRef({}); // Rastrea las solicitudes realizadas

    const [days, setDays] = useState([]);

    const selectorWeather = createSelector(
        (state) => state.DataWeather,
        (result) => ({
            data: result?.itemDataWeatherByType?.['forecast'],
            isLoading: result?.isLoadingList || false,
        })
    );

    const { data, isLoading } = useSelector(selectorWeather);

    useEffect(() => {
        if (code_siep && lat && lon) {
            const key = `${code_siep}-${lat}-${lon}`; // Clave única para evitar duplicados
            if (!hasFetchedData.current[key]) {
                hasFetchedData.current[key] = true; // Marcar que ya se hizo la llamada
                dispatch(getDataWeatherData({ siep: code_siep, lat, lon, type: 'forecast' }));
            }
        }
    }, [code_siep, lat, lon, dispatch]);

    useEffect(() => {
        if (data?.list?.length > 0) {
            const filteredData = data.list.filter((item) => item.dt_txt.includes("12:00:00"));
            setDays(filteredData);
        } else {
            setDays([]);
        }
    }, [data]);

    const getWeatherIconClass = (icon) => {
        const iconsMap = {
            '01d': 'ri-sun-line',
            '01n': 'ri-sun-line',
            '02d': 'ri-cloudy-2-line',
            '02n': 'ri-cloudy-2-line',
            '03d': 'ri-cloud-line',
            '03n': 'ri-cloud-line',
            '04d': 'ri-cloudy-line',
            '04n': 'ri-cloudy-line',
            '09d': 'ri-showers-line',
            '09n': 'ri-showers-line',
            '10d': 'ri-rainy-line',
            '10n': 'ri-rainy-line',
            '11d': 'ri-thunderstorms-line',
            '11n': 'ri-thunderstorms-line',
            '13d': 'ri-snowy-line',
            '13n': 'ri-snowy-line',
            '50d': 'ri-foggy-line',
            '50n': 'ri-foggy-line',
        };
        return iconsMap[icon] || 'ri-cloudy-2-line';
    };


    if (isLoading || days.length == 0) {
        return <OPlaceholder />
    }

    if (lat == null || lon == null) {
        return (
            <Card className='p-0 mb-2 rounded-4'>
                <CardHeader className='p-2 align-items-center d-flex'>
                    <h5 className="flex-grow-1 m-0">
                        <i className="ri-temp-cold-line align-middle me-1 text-muted"></i>Pronóstico de los próximos días
                    </h5>
                </CardHeader>
                <CardBody className='p-2'>
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <div className="text-center">
                            <div className="avatar-md">
                                <span className="avatar-title bg-info-subtle rounded-circle fs-1">
                                    <i className="ri-earth-fill text-info"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </CardBody>                
                <CardFooter className="m-0 p-2 text-center">
                    <h6 className="mb-0 p-0 text-wrap w-100">
                        <span className="fs-11 badge bg-info-subtle text-info text-wrap">
                        No cuenta con coordenadas
                        </span>
                    </h6>
                </CardFooter>
            </Card>
        );
    }

    return (
        <Card className='p-0 mb-2 rounded-4'>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className="flex-grow-1 m-0">
                    <i className="ri-temp-cold-line align-middle me-1 text-muted"></i>Pronóstico de los próximos días
                </h5>
            </CardHeader>
            <CardBody className="p-2">
                {days.length > 0 ? (
                    <div
                        style={{
                            textAlign: 'center',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(5, minmax(20px, 1fr))',
                            gap: '2px',
                        }}
                    >
                        {days.map((day, index) => (
                            <div key={index}>
                                <div className="fs-10 text-uppercase fw-medium text-muted text-truncate">
                                    {new Date(day.dt_txt).toLocaleDateString('es-ES', {
                                        weekday: 'long',
                                    }).slice(0, 3)}
                                </div>
                                <i className={`fs-16 ${getWeatherIconClass(day.weather[0].icon)}`}></i>
                                <div className="fw-bold fs-13">{Math.floor(day.main.temp_max)}°C</div>
                                <div className="fs-10">{Math.floor(day.main.temp_min)}°C</div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center m-0">No hay datos disponibles para mostrar.</p>
                )}
            </CardBody>
        </Card>
    );
};

export default WeatherForecast;
